module.exports = __webpack_public_path__ + "static/media/passion_about.66327309.png";